import { Chip } from "@mui/material";
import { capitalize } from "lodash";

const RewardsStatus = ({
  status,
  map,
}: {
  status?: string | null;
  map?: {
    [key: string]:
    | "success"
    | "info"
    | "error"
    | "warning"
    | "default"
    | "primary"
    | "secondary";
  };
}) => {
  const statusText = capitalize(status || "");
  const key = statusText.trim().toLowerCase();
  const colors: {
    [key: string]:
    | "success"
    | "info"
    | "error"
    | "warning"
    | "default"
    | "primary"
    | "secondary";
  } = {
    active: "success",
    pending: "warning",
    inactive: "warning",
    ended: "error",
    new: "success",
    redeemed: "info",
    used: "warning",
    expired: "error",
    "": "warning",
  };

  const color =
    (map && map[key]) ||
    colors[key] ||
    "warning";

  return (
    <Chip
      style={{ maxWidth: "70%", fontSize: "10px", width: "140px" }}
      label={statusText || "-"}
      size="small"
      color={color}
    />
  );
};

export default RewardsStatus;
